// The document types the AI document library accepts. A pre-flight UX
// check only, not the source of truth: it mirrors backend/services/
// document_service.py's ALLOWED_EXTENSIONS, and the backend re-validates
// (and enforces the size limit) regardless. Legacy binary Office formats
// (.doc/.ppt/.xls) are not supported.
export const DOCUMENT_EXTENSIONS = ['pdf', 'docx', 'pptx', 'xlsx', 'csv', 'txt'];

// The <input type="file"> accept value.
export const DOCUMENT_ACCEPT = DOCUMENT_EXTENSIONS.map((extension) => `.${extension}`).join(',');

export const DOCUMENT_TYPES_LABEL = 'PDF, DOCX, PPTX, XLSX, CSV, TXT';

export const DOCUMENT_UNSUPPORTED_MESSAGE = `Unsupported file type. Allowed types: ${DOCUMENT_TYPES_LABEL}.`;

export function extensionOf(fileName) {
  const match = /\.([^.]+)$/.exec(fileName || '');
  return match ? match[1].toLowerCase() : '';
}
